module.exports = __webpack_public_path__ + "static/media/group-dance.df364049.jpg";